import { render, staticRenderFns } from "./SelfReportSelect.vue?vue&type=template&id=54ab9d8c&scoped=true"
import script from "./SelfReportSelect.vue?vue&type=script&lang=js"
export * from "./SelfReportSelect.vue?vue&type=script&lang=js"
import style0 from "./SelfReportSelect.vue?vue&type=style&index=0&id=54ab9d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ab9d8c",
  null
  
)

export default component.exports